import { combineReducers } from 'redux';

import {
  HIDE_ASSIGN_MODAL,
  OPEN_ASSIGN_MODAL,
  ASSIGN_ENTITY_FROM_GROUP_REQUEST,
  ASSIGN_ENTITY_FROM_GROUP_SUCCESS,
} from 'modules/groups/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   visible: boolean,
 *   dataId: string|null,
 *   loading: boolean
 * }} GroupAssigningUIReducer
 */

export default combineReducers({
  visible: createReducer(false, {
    [OPEN_ASSIGN_MODAL]: () => true,
    [HIDE_ASSIGN_MODAL]: () => false,
    [LOCATION_CHANGE]: () => false,
    [ASSIGN_ENTITY_FROM_GROUP_SUCCESS]: () => false,
  }),
  dataId: createReducer(null, {
    [OPEN_ASSIGN_MODAL]: (_, { payload }) => payload,
    [HIDE_ASSIGN_MODAL]: () => null,
    [LOCATION_CHANGE]: () => null,
  }),
  loading: createReducer(false, {
    [ASSIGN_ENTITY_FROM_GROUP_REQUEST]: () => true,
    [HIDE_ASSIGN_MODAL]: () => false,
    [OPEN_ASSIGN_MODAL]: () => false,
    [LOCATION_CHANGE]: () => false,
  }),
});
